import ConnectServer from 'utils/connect_server'
import * as types from 'redux/types'
import { message } from 'antd';


export const onChangeAccount = (prop, value): any => (dispatch) => {
  dispatch({ type: types.CHANGE_ACCOUNT, payload: { prop, value } });
}


export const getInfoAction = (id): any => (dispatch) => {
  onChangeAccount('getInfoLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/view-customer?id=${id}`, "GET", null, null).then((res: any) => {
    onChangeAccount('allInfoUser',res)(dispatch)  
    return res
  }).finally(() => { 
    onChangeAccount('getInfoLoading',false)(dispatch)  
  })
}
export const updateInfoAction = (data): any => (dispatch) => {
  onChangeAccount('updateInfoLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/update-user`, "POST", null, data).then((res: any) => {
    
    return res
  }).finally(() => { 
    onChangeAccount('updateInfoLoading',false)(dispatch)  
  })
}


export const getSmsListAction = (query): any => (dispatch) => {
  onChangeAccount('getSmsListLoading',true)(dispatch)
  return ConnectServer(`message/index${query}`, "GET", null, null).then((res: any) => {
    onChangeAccount('smsList',res.items)(dispatch)  
    onChangeAccount('smsListMeta',res._meta)(dispatch)  
    return res
  }).finally(() => { 
    onChangeAccount('getSmsListLoading',false)(dispatch)  
  })
}